function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigation } from "@react-navigation/native";
import { Kind } from "@oui/lib/src/types";
import { ChatInputChoice } from "./ChatInputChoice";
import { View } from "./View";
import { useContactsPickerResult } from "../hooks/useContactsPickerResult";
var noopOnInput = function() {};
/**
 * A `ChatInput` variant that interacts with the device's contact list to allow
 * selection of one or more contacts.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-52}
 */ export function ChatInputContactsPicker(_param) {
    var _param_onInput = _param.onInput, onInput = _param_onInput === void 0 ? noopOnInput : _param_onInput, props = _object_without_properties(_param, [
        "onInput"
    ]);
    var navigate = useNavigation().navigate;
    var label = {
        0: 'Add from contacts',
        1: 'Add new'
    };
    if (props.allowSkip) {
        label[2] = 'Not now';
    }
    var returnRoute = useContactsPickerResult(function(param) {
        var contacts = param.contacts, permissionDenied = param.permissionDenied;
        if (permissionDenied) {
            onInput({
                kind: Kind.InputContactsPicker,
                props: {
                    result: 'custom',
                    contacts: []
                }
            });
        } else {
            onInput({
                kind: Kind.InputContactsPicker,
                props: {
                    result: 'contacts',
                    contacts: contacts
                }
            });
        }
    });
    return /*#__PURE__*/ _jsx(View, {
        children: /*#__PURE__*/ _jsx(ChatInputChoice, {
            onInput: function(action) {
                if (action.kind === Kind.InputChoice) {
                    var choice = action.props[0];
                    if (choice === 0) {
                        // Open contacts chooser
                        navigate('ContactsPicker', {
                            returnRoute: returnRoute
                        });
                    } else if (choice === 1) {
                        // continue conversation
                        onInput({
                            kind: Kind.InputContactsPicker,
                            props: {
                                result: 'custom',
                                contacts: []
                            }
                        });
                    } else if (choice === 2) {
                        onInput({
                            kind: Kind.InputContactsPicker,
                            props: {
                                result: 'skip',
                                contacts: []
                            }
                        });
                    }
                }
            },
            label: label
        })
    });
}
